import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const ManageProvisioningStyles: moduleStyleType = {
    rectangle: {
        backgroundColor: 'background.paper',
        border: '1px solid',
        borderColor: 'border.primary',
        borderRadius: '6px',
        display: 'flex',
        minWidth: '200px',
        maxWidth: '50%',
        marginBottom: 'auto',
        overflow: 'auto',
    },
}
